export default {
    slug: 'inventory',
    ability: 'inventory',
    routes: [
        {
            path: 'inventory/warehouses',
            name: 'warehouse-list',
            component: () => import('@modules/Inventory/Resources/js/pages/warehouses/List.vue'),
            children: [
                {
                    path: ':id(\\d+)',
                    name: 'warehouse-preview',
                    component: () => import('@modules/Inventory/Resources/js/pages/warehouses/Preview.vue'),
                    redirect: { name: 'warehouse-overview' },
                    props: true,
                    children: [
                        {
                            path: '/organization/:org/inventory/warehouses/:id(\\d+)',
                            name: 'warehouse-overview',
                            component: () =>
                                import('@modules/Inventory/Resources/js/pages/warehouses/preview/Overview.vue'),
                            props: true
                        },
                        {
                            path: 'locations',
                            name: 'warehouse-locations',
                            component: () =>
                                import('@modules/Inventory/Resources/js/pages/warehouses/preview/Locations.vue'),
                            props: true
                        },
                        {
                            path: 'logs',
                            name: 'warehouse-logs',
                            component: () => import('@/components/base/tabs/TabLogs.vue'),
                            props: true
                        },
                        {
                            path: 'documents/:docPath(.*)*',
                            name: 'warehouse-documents',
                            component: () => import('@/components/base/tabs/TabDocuments.vue'),
                            props: true
                        }
                    ]
                }
            ]
        },
        {
            path: 'purchases/receipts/:id(\\d+)',
            name: 'purchase-receipt-preview',
            component: () => import('@modules/Inventory/Resources/js/pages/receipts/Preview.vue'),
            props: true
        },
        {
            path: 'inventory/stock',
            name: 'inventory-stock',
            component: () => import('@modules/Inventory/Resources/js/pages/Stock.vue')
        },
        {
            path: 'inventory/movements',
            name: 'inventory-movements',
            component: () => import('@modules/Inventory/Resources/js/pages/Movements.vue')
        }
    ],
    nav: () => ({
        section: 'inventory',
        items: [
            { title: i18n.t('Warehouses'), icon: 'warehouse', to: { name: 'warehouse-list' } },
            { title: i18n.t('Stock'), icon: 'package-variant-closed', to: { name: 'inventory-stock' } },
            { title: i18n.t('Movements'), icon: 'swap-horizontal', to: { name: 'inventory-movements' } }
        ]
    })
};
